import { createSelector } from 'reselect';

export const E1 = 'https://cdaas-dev.americanexpress.com/one/one-identity-session';
export const E2 = 'https://qwww.aexp-static.com/cdaas/one/one-identity-session';
export const E3 = 'https://www.aexp-static.com/cdaas/one/one-identity-session';

export const getLocaleFilename = (state) => (state
&& state.config
&& state.config.toJS().localeFilename) || {};

export const getEnvironment = createSelector(
  [getLocaleFilename],
  (localeFilename) => {
    switch (localeFilename) {
      case 'integration':
        return E1;
      case 'qa':
        return E2;
      default:
        return E3;
    }
  }
);
